import React from 'react';
import styles from './Header.module.css';
import {
  BaseStyles,
  Flex,
  Box,
  Button,
  Heading,
  Text,
  MetaMaskButton,
  Image,
  Link,
} from 'rimble-ui';
import logo from '../../assets/nftMultisendLogo.jpg';

import { Eth } from '@rimble/icons';
import { ethers } from 'ethers';
import { connectToMetamask } from '../../apis/blockchain';
import { ID_TO_NETWORK } from '../../constants';

function Header(props) {
  return (
    <BaseStyles>
      <Flex className={styles.root}>
        <Box className={styles.mainLogo}>
          {/*<Eth size={80} />*/}
          <Image alt='logo' borderRadius={8} height='80px' src={logo} />
          <Heading as='h1'>NFT Multisend</Heading>
        </Box>
        <Box>
          {!props.isMetamaskConnected ? (
            <Flex>
              <Box>
                <MetaMaskButton
                  onClick={() => {
                    props.connectToMetamask();
                  }}
                >
                  Connect with MetaMask
                </MetaMaskButton>
              </Box>
            </Flex>
          ) : (
            <>
              <Flex>
                <Box>
                  <Heading as='h2'>
                    Network: {ID_TO_NETWORK[props.networkId]}
                  </Heading>
                </Box>
              </Flex>
              <Flex>
                <Box>
                  <Heading as='h2'>ETH Address: {props.ethAddress}</Heading>
                </Box>
              </Flex>
              <Flex>
                <Box>
                  <Link
                    href='https://t.me/ZeroUtilityToken'
                    target='_blank'
                    title='View Telegram group'
                    color='black'
                    primaryColor='black'
                    hoverColor='black'
                  >
                    <Heading as='h2' className={styles.links}>
                      <Image
                        alt='telegram icon'
                        borderRadius={0}
                        height='20px'
                        src='https://img.icons8.com/ios-filled/50/000000/telegram-app.png'
                      />
                      Telegram
                    </Heading>
                  </Link>
                </Box>
                <Box>
                  <Link
                    href='https://etherscan.io/address/0x38996fd29d0b3235d26ace30a6305bbdc6fc9caf'
                    target='_blank'
                    title='View Contract on Etherscan'
                    color='black'
                    primaryColor='black'
                    hoverColor='black'
                  >
                    <Heading as='h2' className={styles.links}>
                      <Image
                        alt='etherscan logo'
                        borderRadius={10}
                        height='20px'
                        src='https://etherscan.io/images/brandassets/etherscan-logo-circle.png'
                      />
                      Etherscan
                    </Heading>
                  </Link>
                </Box>
              </Flex>
            </>
          )}
        </Box>
      </Flex>
    </BaseStyles>
  );
}

export default Header;
